/**
 * @name ToasterMessageType
 * @enum number
 * @type {{Warning: number, Error: number, Success: number}}
 */
export const ToasterMessageType = {
  Success: 1,
  Warning: 2,
  Error: 3,
}